import ProductionOrderCalendar from '@/components/production_orders/ProductionOrderCalendar'

export default function Calendar() {
    return <ProductionOrderCalendar />
}
